class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();

    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);
    this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this));
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const facetDrawer = document.getElementById('FacetDrawer');
    const countContainer = document.getElementById('ProductCount');
    const countContainerMobile = document.getElementById('ProductCountMobile');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');

    const gridContainer = document.getElementById('ProductGridContainer');
    if (gridContainer) {
      const collection = gridContainer.querySelector('.collection');
      if (collection) collection.classList.add('loading');
    }

    if (countContainer) countContainer.classList.add('loading');
    if (countContainerMobile) countContainerMobile.classList.add('loading');
    if (countContainerDesktop) countContainerDesktop.classList.add('loading');
    if (facetDrawer) facetDrawer.classList.add('loading');

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      })
      .catch((e) => {
        console.error('FacetFiltersForm fetch error:', e);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const newGrid = parsed.getElementById('ProductGridContainer');
    const currentGrid = document.getElementById('ProductGridContainer');
    if (newGrid && currentGrid) {
      currentGrid.innerHTML = newGrid.innerHTML;
    }

    const layoutSwitcher = document.querySelector('#FacetFiltersForm layout-switcher');
    if (layoutSwitcher) {
      const activeBtn = layoutSwitcher.querySelector('.list-view__item--active');
      if (activeBtn) layoutSwitcher.onButtonClick(activeBtn);
    }
  }

  static renderProductCount(html) {
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const countEl = parsed.getElementById('ProductCount');
    if (!countEl) return;
    const count = countEl.innerHTML;

    ['ProductCount', 'ProductCountMobile', 'ProductCountDesktop'].forEach((id) => {
      const el = document.getElementById(id);
      if (el) {
        el.innerHTML = count;
        el.classList.remove('loading');
      }
    });
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter'
    );

    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };

    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      const target = document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`);
      if (target) target.innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
    }

    const facetDrawer = document.getElementById('FacetDrawer');
    if (facetDrawer) facetDrawer.classList.remove('loading');
  }

  static renderActiveFacets(html) {
    ['.active-facets-mobile', '.active-facets-desktop'].forEach((selector) => {
      const source = html.querySelector(selector);
      const target = document.querySelector(selector);
      if (source && target) target.innerHTML = source.innerHTML;
    });
  }

  static renderAdditionalElements(html) {
    ['.mobile-facets__open', '.facets__open', '.sorting'].forEach((selector) => {
      const source = html.querySelector(selector);
      const target = document.querySelector(selector);
      if (source && target) target.innerHTML = source.innerHTML;
    });

    const drawerEl = document.getElementById('FacetFiltersFormMobile');
    if (drawerEl) {
      const drawer = drawerEl.closest('facet-drawer');
      if (drawer && typeof drawer.bindEvents === 'function') drawer.bindEvents();
    }
  }

  static renderCounts(source, target) {
    if (!source || !target) return;
    const sourceEl = source.querySelector('.facets__selected');
    const targetEl = target.querySelector('.facets__selected');
    if (sourceEl && targetEl) {
      targetEl.outerHTML = sourceEl.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      '',
      `${window.location.pathname}${searchParams ? '?' + searchParams : ''}`
    );
  }

  static getSections() {
    const grid = document.getElementById('product-grid');
    if (!grid) return [];
    return [{ section: grid.dataset.id }];
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const formData = new FormData(event.target.closest('form'));
    const searchParams = new URLSearchParams(formData).toString();
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.renderPage(new URL(event.currentTarget.href).searchParams.toString());
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();


class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const link = this.querySelector('a');
    if (!link) return;
    link.addEventListener('click', (event) => {
      event.preventDefault();
      const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
      if (form) form.onActiveFilterClick(event);
    });
  }
}
customElements.define('facet-remove', FacetRemove);


class PriceRange extends HTMLElement {
  constructor() {
    super();

    this.min = Number(this.dataset.min);
    this.max = Number(this.dataset.max);
    this.track = this.querySelector('.price-range__track');
    this.handles = [...this.querySelectorAll('.price-range__thumbs')];
    this.startPos = 0;
    this.activeHandle = null;
    this.moveListener = null;

    this.handles.forEach(handle => {
      handle.addEventListener('mousedown', this.startMove.bind(this));
    });

    window.addEventListener('mouseup', this.stopMove.bind(this));

    this.querySelectorAll('input').forEach(
      element => element.addEventListener('change', this.onRangeChange.bind(this))
    );
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  startMove(e) {
    this.startPos = e.offsetX;
    this.activeHandle = e.target;
    this.moveListener = this.move.bind(this);
    window.addEventListener('mousemove', this.moveListener);
  }

  move(e) {
    if (!this.activeHandle || !this.track) return;
    const isLower = this.activeHandle.classList.contains('is-lower');
    const property = isLower ? '--progress-lower' : '--progress-upper';
    const parentRect = this.track.getBoundingClientRect();
    const handleRect = this.activeHandle.getBoundingClientRect();
    let newX = e.clientX - parentRect.x - this.startPos;

    if (isLower) {
      const otherX = parseInt(this.style.getPropertyValue('--progress-upper')) || 100;
      const percentageX = otherX * parentRect.width / 100;
      newX = Math.min(newX, percentageX - handleRect.width);
      newX = Math.max(newX, -(handleRect.width / 2));
    } else {
      const otherX = parseInt(this.style.getPropertyValue('--progress-lower')) || 0;
      const percentageX = otherX * parentRect.width / 100;
      newX = Math.max(newX, percentageX);
      newX = Math.min(newX, parentRect.width - handleRect.width / 2);
    }

    const percentage = (newX + handleRect.width / 2) / parentRect.width;
    const valuenow = this.calcHandleValue(percentage);
    this.style.setProperty(property, percentage * 100 + '%');
    this.activeHandle.ariaValueNow = valuenow;

    const output = this.activeHandle.nextElementSibling;
    if (output) {
      const text = output.querySelector('.price-range__output-text');
      if (text) text.innerHTML = valuenow;
    }

    const inputs = this.querySelectorAll('input');
    const input = isLower ? inputs[0] : inputs[1];
    if (input) {
      input.value = valuenow;
      this.adjustToValidValues(input);
      this.setMinAndMaxValues();
    }
  }

  calcHandleValue(percentage) {
    return Math.round(percentage * (this.max - this.min) + this.min);
  }

  stopMove() {
    if (this.moveListener) {
      window.removeEventListener('mousemove', this.moveListener);
      this.moveListener = null;
    }
    if (this.activeHandle) {
      const form = this.closest('form');
      if (form) form.dispatchEvent(new Event('input'));
      this.activeHandle = null;
    }
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (!minInput || !maxInput) return;
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', minInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));
    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}
customElements.define('price-range', PriceRange);


class LayoutSwitcher extends HTMLElement {
  constructor() {
    super();

    this.cookieName = 'beyours:collection-layout';
    this.initLayoutMode();

    this.querySelectorAll('.list-view__item').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    const target = event.target ? event.target : event;
    this.changeLayoutMode(target, target.dataset.layoutMode);
  }

  initLayoutMode() {
    if (!isStorageSupported('local')) return;
    const layoutMode = window.localStorage.getItem(this.cookieName);
    if (!layoutMode) return;
    const target = this.querySelector(`.list-view__item[data-layout-mode="${layoutMode}"]`);
    if (target) this.changeLayoutMode(target, layoutMode);
  }

  changeLayoutMode(target, layoutMode) {
    const productGrid = document.getElementById('product-grid');
    if (!productGrid || !layoutMode) return;
    if (productGrid.classList.contains('collection--empty')) return;

    const toRemove = [
      'list', 'grid', 'grid--1-col', 'grid--2-col',
      'grid--3-col-tablet', 'grid--2-col-desktop',
      'grid--3-col-desktop', 'grid--4-col-desktop'
    ];
    toRemove.forEach((cls) => productGrid.classList.remove(cls));

    const toAdd = {
      'list':   ['grid', 'grid--1-col', 'grid--2-col-desktop', 'list'],
      'grid-2': ['grid', 'grid--2-col'],
      'grid-3': ['grid', 'grid--2-col', 'grid--3-col-tablet', 'grid--3-col-desktop'],
      'grid-4': ['grid', 'grid--2-col', 'grid--3-col-tablet', 'grid--4-col-desktop']
    };

    (toAdd[layoutMode] || []).forEach((cls) => productGrid.classList.add(cls));

    this.querySelectorAll('.list-view__item').forEach(
      (button) => button.classList.remove('list-view__item--active')
    );
    if (target) target.classList.add('list-view__item--active');

    if (isStorageSupported('local')) {
      window.localStorage.setItem(this.cookieName, layoutMode);
    }
  }
}
customElements.define('layout-switcher', LayoutSwitcher);


class StickyFacetFilters extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.filters = document.getElementById('main-facet-filters');
    if (!this.filters) return;
    this.onScrollHandler = this.onScroll.bind(this);
    window.addEventListener('scroll', this.onScrollHandler, false);
    this.onScrollHandler();
  }

  disconnectedCallback() {
    if (this.onScrollHandler) {
      window.removeEventListener('scroll', this.onScrollHandler);
    }
  }

  onScroll() {
    if (!this.filters) return;
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (scrollTop >= this.filters.parentNode.offsetTop) {
      requestAnimationFrame(this.reveal.bind(this));
    } else {
      requestAnimationFrame(this.reset.bind(this));
    }
  }

  reveal() {
    if (this.filters) this.filters.classList.add('shopify-section-filters-sticky');
  }

  reset() {
    if (this.filters) this.filters.classList.remove('shopify-section-filters-sticky');
  }
}
customElements.define('sticky-facet-filters', StickyFacetFilters);


/* ── DEBOUNCE ── */
function debounce(fn, wait) {
  let timer;
  return function (...args) {
    clearTimeout(timer);
    timer = setTimeout(() => fn.apply(this, args), wait);
  };
}

/* ── STORAGE SUPPORT CHECK ── */
function isStorageSupported(type) {
  try {
    const storage = type === 'local' ? window.localStorage : window.sessionStorage;
    const testKey = '__bzy_test__';
    storage.setItem(testKey, '1');
    storage.removeItem(testKey);
    return true;
  } catch (e) {
    return false;
  }
}